import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { PropType } from "vue";
import { stylesToClasses } from "@/builder/BuilderUtilities";
import { ITextComponent } from "../../interfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextComponent',
  props: {
    component: {
        type: Object as PropType<ITextComponent>,
        required: true
    },
    text: {
        type: String,
        required: true
    }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-container rd-w-full",
    style: _normalizeStyle(_unref(stylesToClasses)(__props.component.styles)),
    innerHTML: __props.text
  }, null, 12, _hoisted_1))
}
}

})